var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpcomingEventsCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 165,
    viewBox: "0 0 155 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 31.7052V121C0.5 127.075 5.42477 132 11.4996 132H132.5V31.7048H0.5V31.7052Z",
    fill: "#ECF0F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.864 31.7053H132.5V132H124.864V31.7053Z",
    fill: "#D8E4F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.5 165C139.725 165 154.5 150.225 154.5 132C154.5 113.775 139.725 99 121.5 99C103.275 99 88.5 113.775 88.5 132C88.5 150.225 103.275 165 121.5 165Z",
    fill: "#4C9CD6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6516 57.75V57.7501C58.6518 58.9843 57.6513 59.9848 56.4168 59.9848H45.4169C44.1825 59.9848 43.1821 58.9841 43.1821 57.75V46.7501C43.1821 45.5158 44.1828 44.5153 45.4169 44.5153H56.4168C57.6511 44.5153 58.6516 45.516 58.6516 46.7501V57.75Z",
    fill: "#E6E6E6",
    stroke: "#E6E6E6",
    strokeWidth: 1.03018
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8176 57.75V57.7501C89.8179 58.9843 88.8173 59.9848 87.5828 59.9848H76.5829C75.3486 59.9848 74.3481 58.9841 74.3481 57.75V46.7501C74.3481 45.5157 75.3485 44.5153 76.5829 44.5153H87.5828C88.8171 44.5153 89.8176 45.516 89.8176 46.7501V57.75Z",
    fill: "#E6E6E6",
    stroke: "#E6E6E6",
    strokeWidth: 1.03018
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.75 59.9848H107.75C106.516 59.9848 105.515 58.9841 105.515 57.75V46.7501C105.515 45.5158 106.516 44.5153 107.75 44.5153H118.75C119.984 44.5153 120.985 45.516 120.985 46.7501V57.75C120.985 58.9844 119.984 59.9848 118.75 59.9848Z",
    fill: "#E6E6E6",
    stroke: "#E6E6E6",
    strokeWidth: 1.03018
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3441 87.4851H14.1559C12.9737 87.4851 12.0151 86.5266 12.0151 85.3443V74.1562C12.0151 72.9739 12.9737 72.0153 14.1559 72.0153H25.3441C26.5263 72.0153 27.4849 72.9739 27.4849 74.1562V85.3443C27.4849 86.5266 26.5263 87.4851 25.3441 87.4851Z",
    fill: "#E6E6E6",
    stroke: "#E6E6E6",
    strokeWidth: 1.03018
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5111 87.4849H45.3229C44.1407 87.4849 43.1821 86.5263 43.1821 85.3441V74.1559C43.1821 72.9737 44.1407 72.0151 45.3229 72.0151H56.5111C57.6933 72.0151 58.6519 72.9737 58.6519 74.1559V85.3441C58.6519 86.5263 57.6933 87.4849 56.5111 87.4849Z",
    fill: "#E6E6E6",
    stroke: "#E6E6E6",
    strokeWidth: 1.03018
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6771 87.4849H76.4889C75.3067 87.4849 74.3481 86.5263 74.3481 85.3441V74.1559C74.3481 72.9737 75.3067 72.0151 76.4889 72.0151H87.6771C88.8593 72.0151 89.8179 72.9737 89.8179 74.1559V85.3441C89.8179 86.5263 88.8593 87.4849 87.6771 87.4849Z",
    fill: "#E6E6E6",
    stroke: "#E6E6E6",
    strokeWidth: 1.03018
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5111 114.985H45.3229C44.1407 114.985 43.1821 114.026 43.1821 112.844V101.656C43.1821 100.474 44.1407 99.5151 45.3229 99.5151H56.5111C57.6933 99.5151 58.6519 100.474 58.6519 101.656V112.844C58.6519 114.026 57.6933 114.985 56.5111 114.985Z",
    fill: "#E6E6E6",
    stroke: "#E6E6E6",
    strokeWidth: 1.03018
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M118.844 87.4849H107.656C106.474 87.4849 105.515 86.5263 105.515 85.3441V74.1559C105.515 72.9737 106.474 72.0151 107.656 72.0151H118.844C120.026 72.0151 120.985 72.9737 120.985 74.1559V85.3441C120.985 86.5264 120.027 87.4849 118.844 87.4849Z",
    fill: "#E6E6E6",
    stroke: "#E6E6E6",
    strokeWidth: 1.03018
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3441 114.985H14.1559C12.9737 114.985 12.0151 114.026 12.0151 112.844V101.656C12.0151 100.474 12.9737 99.5151 14.1559 99.5151H25.3441C26.5263 99.5151 27.4849 100.474 27.4849 101.656V112.844C27.4849 114.026 26.5263 114.985 25.3441 114.985Z",
    fill: "#E6E6E6",
    stroke: "#E6E6E6",
    strokeWidth: 1.03018
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M132.5 33V16.5C132.5 10.4249 127.575 5.50049 121.5 5.50049H110.5H22.4998H11.4996C5.42444 5.50049 0.5 10.4253 0.5 16.5V33H132.5Z",
    fill: "#3E7EEE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16.5C22.5 19.5374 24.9624 22.0001 28.0001 22.0001C31.0378 22.0001 33.5002 19.5377 33.5002 16.5V5.50011C33.5002 2.46238 31.0378 0 28.0001 0C24.9624 0 22.5 2.46238 22.5 5.50011V16.5Z",
    fill: "#ECF0F9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61 16.5C61 19.5374 63.4624 22.0001 66.5001 22.0001C69.5378 22.0001 72.0002 19.5377 72.0002 16.5V5.50011C72.0002 2.46238 69.5378 0 66.5001 0C63.4624 0 61 2.46238 61 5.50011V16.5Z",
    fill: "#ECF0F9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5003 16.5C99.5003 19.5374 101.963 22.0001 105 22.0001C108.038 22.0001 110.501 19.5377 110.501 16.5V5.50011C110.5 2.46238 108.038 0 105 0C101.962 0 99.5 2.46238 99.5 5.50011V16.5H99.5003Z",
    fill: "#ECF0F9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M132.5 16.5C132.5 10.4249 127.575 5.50049 121.5 5.50049H113.864C119.939 5.50049 124.864 10.4253 124.864 16.5V33H132.5V16.5Z",
    fill: "#23273B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M121.5 165C139.725 165 154.5 150.225 154.5 132C154.5 113.775 139.725 99 121.5 99C103.275 99 88.5 113.775 88.5 132C88.5 150.225 103.275 165 121.5 165Z",
    fill: "#4C9CD6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M121.5 99C120.208 99 118.935 99.0767 117.682 99.2211C134.108 101.114 146.864 115.066 146.864 132C146.864 148.934 134.108 162.886 117.682 164.779C118.935 164.923 120.208 165 121.5 165C139.725 165 154.5 150.225 154.5 132C154.5 113.775 139.725 99 121.5 99Z",
    fill: "#3689C9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M121.5 154C133.65 154 143.5 144.15 143.5 132C143.5 119.85 133.65 110 121.5 110C109.35 110 99.5 119.85 99.5 132C99.5 144.15 109.35 154 121.5 154Z",
    fill: "#ECF0F9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M132.5 134.49H121.5C120.125 134.49 119.01 133.376 119.01 132V121C119.01 119.625 120.125 118.51 121.5 118.51C122.875 118.51 123.99 119.625 123.99 121V129.51H132.5C133.875 129.51 134.99 130.625 134.99 132C134.99 133.375 133.875 134.49 132.5 134.49Z",
    fill: "#595A66"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M121.5 110C120.196 110 118.922 110.12 117.682 110.337C128.011 112.145 135.864 121.153 135.864 132C135.864 142.847 128.011 151.855 117.682 153.663C118.922 153.88 120.196 154 121.5 154C133.65 154 143.5 144.15 143.5 132C143.5 119.85 133.65 110 121.5 110Z",
    fill: "#D8E4F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingEventsCalendar);
export default __webpack_public_path__ + "static/media/UpcomingEventsCalendar.76bae48bd4fde0b8aa8a26334e050bad.svg";
export { ForwardRef as ReactComponent };